import { InputAdornment, TextField } from "@material-ui/core";
import { useSelector } from "react-redux";
import { useCountry, useCurrency } from "../../provider/courtryProvider";
import DoubleArrow from "../../assets/icons/Vector.svg";
import { useBilling } from "../Kitchen/billingProvider";
import { memo, useRef, useState } from "react";
import DeliverAddressModal from "./deliveryAddressModal";
import CouponModal from "./couponModal";
import NotesModal from "./notesModal";
import OtherChargesModal from "./otherChargeModal";
import HoldBtn from "./holdBtn";
import { useFooterData } from "../../provider/billingProviders/footerDataProvider";
import { MdAddCircleOutline } from "react-icons/md";
import { useCustomerData } from "../../provider/billingProviders/customerDataProvider";
import { RiCloseCircleLine } from "react-icons/ri";
import { AiOutlineMinusCircle } from "react-icons/ai";
import useOnClickOutside from "../../hooks/useOutsideClick";
import { GENERATEBILLACCESS } from "../../utils/constant";
import { useAccess } from "../../provider/AccessProvider";
import { IoIosCloseCircleOutline } from "react-icons/io";

const BillingFooter = () => {
  const invoiceSettingsValue = useSelector(
    (state) => state.newInvoicesettings.newInvoicesettings
  );
  const {
    customerData: { loyalty = {} },
    removeLoyaltyPoints,
  } = useCustomerData();
  const closeTotal = useRef();
  useOnClickOutside(closeTotal, () => setOtherBillDetailsModal(false));
  const [otherBillDetailsModal, setOtherBillDetailsModal] = useState(false);
  const {
    removeCoupon,
    footerData: { coupon = {} },
  } = useFooterData();
  const invoiceSettings = useSelector(
    (state) => state.newInvoicesettings.newInvoicesettings
  );
  const access = useAccess(GENERATEBILLACCESS);
  const [notesModal, setNotesModal] = useState(false);
  const [deliveryAddr, setDeliveryAddr] = useState(false);
  const [offersModal, setOffersModal] = useState(false);
  const { getSubTotal } = useBilling();
  const { getTotalAmount } = useFooterData();
  const { getOtherChargeValue } = useFooterData();
  const currencyFormatter = useCurrency();
  const total = getTotalAmount();
  const subTotal = getSubTotal();
  const country = useCountry();
  const [otherChargesModal, setOtherChargesModal] = useState(false);
  const otherCharge = getOtherChargeValue();
  const { footerData, setFooterData, getLoyaltyDiscount } = useFooterData();
  const loyaltyDiscount = getLoyaltyDiscount();

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div className="holdCancelButton">
          <div>
            <HoldBtn />
          </div>
          {invoiceSettingsValue.deliveryaddress ? (
            <div>
              <p
                className="delivery"
                onClick={() => setDeliveryAddr(true)}
                style={{ marginLeft: "11px" }}
                id="deliveryAddressBtn"
              >
                <p>Delivery Address</p>
              </p>
            </div>
          ) : (
            <div style={{ marginLeft: "10px" }}></div>
          )}
          <div>
            <p
              className="coupon"
              onClick={() => {
                if (!access.couponDiscount()) {
                  return;
                }
                setOffersModal(true);
              }}
              id="couponDiscountBtn"
            >
              <p>Coupon Disc.</p>
            </p>
          </div>
          {invoiceSettingsValue.notes && (
            <div>
              <p
                className="notes"
                id="notesBtn"
                onClick={() => {
                  setNotesModal(true);
                }}
              >
                <p>Notes</p>
              </p>
            </div>
          )}
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
            position: "relative",
          }}
        >
          {invoiceSettingsValue.othercharges && (
            <div>
              {invoiceSettingsValue.othercharges && (
                <div
                  style={{ display: "flex", alignItems: "center" }}
                  id="otherCharges"
                >
                  <div
                    className="otherChargesNew"
                    onClick={() => {
                      if (!access.otherCharges()) {
                        return;
                      }
                      setOtherChargesModal(true);
                    }}
                    style={{
                      cursor: "pointer",
                      fontSize: "16px",
                      letterSpacing: "1px",
                      fontFamily: "sans-serif",
                    }}
                  >
                    + Other Charges
                  </div>
                  <div
                    className="otherChargesNewAmount"
                    onClick={() => {
                      setOtherChargesModal(true);
                    }}
                    style={{
                      cursor: "pointer",
                      fontFamily: "sans-serif",
                    }}
                  >
                    ({country.CurrencySymbol}
                    {otherCharge})
                  </div>
                </div>
              )}
            </div>
          )}

          {otherBillDetailsModal && (
            <div ref={closeTotal} className="otherDetailsPopup">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div>Subtotal</div>
                <div>{currencyFormatter(subTotal)}</div>
              </div>
              <hr
                style={{
                  borderTop: "dotted 1px",
                  marginTop: " 5px",
                  marginBottom: " 5px",
                }}
              />
              <div className="addedCharges">
                <div
                  style={{
                    display: "flex",
                    letterSpacing: "1px",
                    color: "#208441",
                    alignItems: "center",
                  }}
                >
                  {" "}
                  <MdAddCircleOutline />{" "}
                  <span style={{ marginLeft: "4px" }}>Other Charges</span>
                </div>
                {footerData.otherCharges.map((data) => (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                    key={data.id}
                  >
                    <div
                      style={{
                        letterSpacing: "1px",
                        fontSize: "16px",
                        marginBottom: "7px",
                      }}
                    >
                      {data.name}
                    </div>
                    <div>
                      {parseFloat(data.price)
                        ? `${currencyFormatter(parseFloat(data.price))}`
                        : currencyFormatter(0)}
                    </div>
                  </div>
                ))}
                <hr
                  style={{
                    borderTop: "dotted 1px",
                    marginTop: " 5px",
                    marginBottom: " 5px",
                  }}
                />
                <div style={{ textAlign: "right" }}>
                  {currencyFormatter(otherCharge)}
                </div>
              </div>
              <div className="deductedCharges">
                <div
                  style={{
                    display: "flex",
                    letterSpacing: "1px",
                    color: "#CF0000",
                    alignItems: "center",
                    marginBottom: "3px",
                  }}
                >
                  <AiOutlineMinusCircle />
                  <span style={{ marginLeft: "4px" }}>
                    Other Reductions
                  </span>{" "}
                </div>
                {Object.keys(coupon).length > 0 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ fontSize: "16px" }}>Coupon</div>
                      <div
                        style={{
                          fontSize: "10px",
                          marginLeft: "5px",
                        }}
                      >
                        Discount ({coupon.promocode})
                      </div>
                      <div
                        className="appliedCouponClosure"
                        onClick={() => removeCoupon(coupon)}
                      >
                        <RiCloseCircleLine />
                      </div>
                    </div>
                    <div>
                      -{currencyFormatter(footerData.couponDiscountAmount)}
                    </div>
                  </div>
                )}

                {invoiceSettings.adddiscount && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>Discount</div>
                    {footerData.discount ? (
                      <div style={{ display: "flex" }}>
                        <div>{footerData.discountType}</div>
                        <div style={{ marginLeft: "5px" }}>
                          {footerData.discountType === "flat"
                            ? country.CurrencySymbol
                            : "%"}{" "}
                          {footerData.discount}
                        </div>
                      </div>
                    ) : (
                      "00.0"
                    )}
                  </div>
                )}
                {loyaltyDiscount > 0 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                        alignItems: "center",
                      }}
                    >
                      <div>Loyalty Discount</div>
                    </div>
                    <div>-{currencyFormatter(loyaltyDiscount)}</div>
                  </div>
                )}
                {Object.keys(loyalty).length > 0 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>Loyalty Points</div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div
                        onClick={() => removeLoyaltyPoints(loyalty)}
                        style={{ color: "#CF0000", cursor: "pointer" }}
                      >
                        <IoIosCloseCircleOutline size={20} />
                      </div>
                      <div>
                        -{" "}
                        {Object.keys(loyalty).length > 0
                          ? `${loyalty.minLoyaltyPointsReq} Points`
                          : "0 Points"}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          {invoiceSettingsValue.othercharges && (
            <div className="verticalLine"></div>
          )}

          {invoiceSettingsValue.adddiscount && (
            <div
              style={{ display: "flex", alignItems: "center" }}
              id="adddiscount"
            >
              <div
                style={{
                  color: "#5194c6",
                  marginRight: "15px",
                  fontSize: "16px",
                  fontFamily: "sans-serif",
                  letterSpacing: "1px",
                }}
              >
                Discount
              </div>
              <div>
                <TextField
                  id="standard-basic"
                  className="discountNewTextfield"
                  onChange={(e) => {
                    if (!access.discount()) {
                      return;
                    }
                    setFooterData((prev) => ({
                      ...prev,
                      discount: e.target.value,
                    }));
                  }}
                  value={footerData.discount}
                  name="billDiscount"
                  type="number"
                  variant="outlined"
                  inputProps={{
                    style: {
                      padding: "0 !important",
                      fontSize: 13,
                      textAlign: "center",
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <div
                          className="newDiscountTypeUI"
                          onClick={() => {
                            if (footerData.discountType === "flat") {
                              setFooterData((prev) => ({
                                ...prev,
                                discountType: "percentage",
                              }));
                            } else {
                              setFooterData((prev) => ({
                                ...prev,
                                discountType: "flat",
                              }));
                            }
                          }}
                        >
                          {footerData.discountType === "flat"
                            ? country.CurrencySymbol
                            : "%"}
                        </div>
                      </InputAdornment>
                    ),
                  }}
                ></TextField>
              </div>
            </div>
          )}
          {invoiceSettingsValue.adddiscount && (
            <div className="verticalLine"></div>
          )}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "200px",
            }}
          >
            <div
              style={{
                marginRight: "15px",
                fontSize: "16px",
                fontFamily: "sans-serif",
                letterSpacing: "1px",
              }}
            >
              Subtotal
            </div>
            <div
              style={{
                fontSize: "16px",
                letterSpacing: "1px",
                fontFamily: "sans-serif",
              }}
            >
              {currencyFormatter(subTotal)}
            </div>
          </div>
          <div className="verticalLine"></div>

          <div
            // ref={totalButton}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              width: "200px",
            }}
            onClick={() => setOtherBillDetailsModal((prev) => !prev)}
            id="totalAmount"
          >
            <div
              style={{
                marginRight: "15px",
                color: "#208441",
                display: "flex",
                alignItems: "center",
                fontSize: "16px",
                letterSpacing: "1px",
              }}
            >
              <img
                src={DoubleArrow}
                // className={
                //   otherBillDetailsModal
                //     ? "rotateCssWhenOpen"
                //     : "rotateCssWhenClose"
                // }
                alt="double arrow"
              />
              Total
            </div>
            <div
              style={{
                color: "#208441",
                fontSize: "16px",
                letterSpacing: "1px",
              }}
            >
              {currencyFormatter(parseFloat(total))}
            </div>
          </div>
        </div>
      </div>
      <DeliverAddressModal
        open={deliveryAddr}
        onClose={() => {
          setDeliveryAddr(false);
        }}
      />
      <DeliverAddressModal
        open={deliveryAddr}
        onClose={() => {
          setDeliveryAddr(false);
        }}
      />
      <NotesModal open={notesModal} onClose={() => setNotesModal(false)} />
      <CouponModal open={offersModal} onClose={() => setOffersModal(false)} />
      <OtherChargesModal
        open={otherChargesModal}
        onClose={() => setOtherChargesModal(false)}
      />
    </div>
  );
};

export default memo(BillingFooter);
